module.exports = {
  login:'Connexion',
  taption: 'Taption',
  ways_to_use_taption:'Façons d’utiliser Taption',
  faq:'FAQ',
  pricing:'Tarifs',
  language:'Langue',
  product:'Produits'
}
